import { render, staticRenderFns } from "./TotpCode.vue?vue&type=template&id=6b9210b5&scoped=true"
import script from "./TotpCode.vue?vue&type=script&lang=js"
export * from "./TotpCode.vue?vue&type=script&lang=js"
import style0 from "./TotpCode.vue?vue&type=style&index=0&id=6b9210b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9210b5",
  null
  
)

export default component.exports